/*
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-17 17:09:27
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2022-11-21 14:37:48
 * @FilePath: \plantingSubsidy_web_update\src\utils\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* 自定义脱敏身份证及其它证件号，规则显示前六后四位

@code String/Number => String
*/
const desensitizationCode = function (code = '') {
  let nCode = code ? code.toString() : ''

  if (!nCode && !nCode.trim() && nCode.length === 10) {
    return false
  }
  nCode = nCode.split('')
  for (let i = 7; i < nCode.length - 4; i++) {
    nCode[i] = '*'
  }
  return nCode.join('')
}

export default {
  desensitizationCode
}



// WEBPACK FOOTER //
// ./src/utils/index.js